import { ASSIGN_VENDORS_TO_WAREHOUSE_ROUTE } from '../assignVendorsToWarehousePage';

export default {
    name: 'warehouseFormPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'warehouseForm';
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                detailsPageRoute: ASSIGN_VENDORS_TO_WAREHOUSE_ROUTE,
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
